import {
  ADD_USER,
  LOAD_USER,
  REMOVE_FIREBASE_LISTENERS,
  REMOVE_USER,
  UPDATE_SORTED_INVENTORY,
  UPDATE_SORTED_SHOPPING,
  UPDATE_SORTED_TRASH,
  SIGN_OUT,
  SET_LANGUAGE,
  SHOW_SELECTED_CATEGORY,
  SET_CATEGORY,
  FETCH_INVENTORY,
  FETCH_TRASH,
  FETCH_SHOPPING,
  GET_DATA_FOR_STATISTICS,
  SAVE_REPORT,
} from "../Actions/firebaseActions";
import { CHECK_ITEM, ADD_CUSTOM_TO_SHOP } from "../Actions/shoppingActions";
import { FILTER_ITEMS, EMPTY_FILTER } from "../Actions/searchActions";
import {
  SET_EDIT_ITEM_STATE,
  SET_SELECTED_ITEM,
  ADD_CUSTOM_TO_INV,
} from "../Actions/inventoryActions";

const initialState = {
  email: "",
  username: "",
  filter: "",
  inventory: {},
  shopping: {},
  trash: {},
  listOrder: "date newest",
  editingItem: false,
  category: "all",
  selectedItem: "",
  scan_id: "",
  scan_status: "",
  reportData: { inventory: {}, trash: {} },
};

export default function firebaseReducer(
  state = initialState,
  { type, payload }
) {
  switch (type) {
    case LOAD_USER:
      return {
        ...state,
        email: payload.user.email,
        username: payload.user.username,
        language: payload.user.language,
        listenerActive: payload.listenerActive,
      };
    case GET_DATA_FOR_STATISTICS:
      return { ...state, reportData: payload.reportData };
    case SAVE_REPORT:
      return { ...state };
    case REMOVE_FIREBASE_LISTENERS:
      return { ...state, listenerActive: payload.listenerActive };
    case FETCH_INVENTORY:
      return { ...state };
    case FETCH_SHOPPING:
      return { ...state };
    case FETCH_TRASH:
      return { ...state };
    case ADD_USER:
      return {
        ...state,
        username: payload.username,
        email: payload.email,
        language: payload.language,
      };
    case REMOVE_USER:
      return payload.user;
    case FILTER_ITEMS:
      return {
        ...state,
        filter: payload,
      };
    case EMPTY_FILTER:
      return {
        ...state,
        filter: payload,
      };
    case CHECK_ITEM:
      return {
        ...state,
      };
    case UPDATE_SORTED_INVENTORY:
      return {
        ...state,
        inventory: payload.list,
        listOrder: payload.order,
      };
    case UPDATE_SORTED_TRASH:
      return {
        ...state,
        trash: payload.list,
        listOrder: payload.order,
      };
    case UPDATE_SORTED_SHOPPING:
      return {
        ...state,
        shopping: payload.list,
        listOrder: payload.order,
      };
    case SHOW_SELECTED_CATEGORY:
      let from = payload.from;
      return {
        ...state,
        [from]: payload.list,
        category: payload.category,
      };
    case SET_CATEGORY:
      return { ...state, category: payload.category };
    case SIGN_OUT:
      return {
        ...initialState,
      };
    case SET_LANGUAGE:
      return { ...state, language: payload.language };

    case SET_EDIT_ITEM_STATE:
      return { ...state, editingItem: payload };
    case SET_SELECTED_ITEM:
      return { ...state, selectedItem: payload };
    case ADD_CUSTOM_TO_INV:
      return {
        ...state,
      };
    case ADD_CUSTOM_TO_SHOP:
      return {
        ...state,
      };

    default:
      return state;
  }
}
